export const mutations = {
  RESET: 'RESET',
  TOGGLE_DRAWER: 'DRAWER_TOGGLE_DRAWER',
  UPDATE_WINDOW_SIZE: 'DRAWER_UPDATE_WINDOW_SIZE',
};

export const actions = {};
